import { SemanticUI } from '@iterable/deprecated_react_components';

// type Props = {
//   /** Array of metrics. */
//   metrics: [],
//   /** Callback function when metric changes. */
//   onChange: ({}, { value: string }) => void,
//   /** Placeholder test to show in dropdown. */
//   placeholder: string,
//   /** Currently selected metric. */
//   selectedMetric: {},
// };

const defaultProps = {
  metrics: [],
  onChange: () => {},
  placeholder: 'Select Metric',
  selectedMetric: {},
};

const MetricsDropdown = (props) => {
  const { metrics, onChange, placeholder, selectedMetric } = props;

  /**
   * handleChange
   * Callback function when metric changes.
   * @param { Object } e: The change event.
   * @param { Object } dropdownProps: The props of the dropdown containing the new selected metric.
   * @return { void }
   */
  const handleChange = (e, { value }) => {
    const metric = metrics && metrics.find((m) => m.enumName === value);
    onChange(e, { value: metric });
  };

  /** Dropdown options, need to filter out enumName and displayType. */
  const options = metrics.map(({ text, value }) => ({
    text,
    value,
  }));

  const value = selectedMetric.enumName;

  return (
    <SemanticUI.Dropdown
      placeholder={placeholder}
      fluid
      search
      selection
      onChange={handleChange}
      value={value}
      options={options}
    />
  );
};

export default MetricsDropdown;
MetricsDropdown.defaultProps = defaultProps;
